// Polyfills required for vue-material.

// Object.values

const reduce = Function.bind.call(Function.call, Array.prototype.reduce);
const isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
const concat = Function.bind.call(Function.call, Array.prototype.concat);

if (!Object.values) {
  Object.values = function values(O) {
    return reduce(Object.getOwnPropertyNames(O), function(v, k) { return concat(v, typeof k === 'string' && isEnumerable(O, k) ? [O[k]] : [] ) }, []);
  };
}


// Array.includes()

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);
      var len = o.length >>> 0;
      if (len === 0) {
        return false;
      }
      var n = fromIndex | 0;
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }
      while (k < len) {
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }
      return false;
    }
  });
}


// object keys polyfill

if (!Object.keys) {
  Object.keys = function(obj) {
    var keys = [];

    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        keys.push(i);
      }
    }

    return keys;
  };
}



import Vue from 'vue'
import App from '@/App.vue'
import VShowSlide from 'v-show-slide'
import VueInstagram from 'vue-instagram'

import store from '@/store' 
import router from '@/router'

// import Vuelidate from 'vuelidate'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'


Vue.config.productionTip = false

// Vue.use(VueRouter)
Vue.use(VueMaterial)
Vue.use(VueInstagram)

// Vue.use(VShowSlide)

Vue.use(VShowSlide, {
  customEasing: {
    exampleEasing: 'cubic-bezier(.17,.67,.79,.59)'
  }
})

// Vue.use(Vuelidate);

const vue = new Vue({
  router,
  store,
  render: h => h(App)
  
})

vue.$mount('#app')
